import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../icons/dpo_icon'. 'app/webpack/javascripts/gdpr/icons/dpo_icon.js' implicitly has an 'any' type.
import DpoIcon from '../icons/dpo_icon';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/feedback_block'. 'node_modules/@grnhse/seedling/lib/azalea/components/feedback_block.js' implicitly has an 'any' type.
import { FeedbackBlock } from '@grnhse/seedling/lib/azalea/components/feedback_block';
import { clearFix } from 'polished';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import { ErrorIcon } from '@grnhse/seedling/lib/azalea/icons';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import {
  ContentHeader,
  ContentDescription,
  IconComponent,
  LeftComponentWrapper,
  DataProtectionOfficerCard,
  Link,
} from './components';
import t from 'shared/utils/translation';

type DataProtectionOfficerData = {
  dataProtectionOfficer: string;
  accountContactsPath: string;
};

type AccountContactsPathData = {
  accountContactsPath: string;
};

function DataProtectionOfficer({
  dataProtectionOfficer,
  accountContactsPath,
}: DataProtectionOfficerData) {
  if (dataProtectionOfficer) {
    return (
      <RenderDataProtectionOfficer
        dataProtectionOfficer={dataProtectionOfficer}
        accountContactsPath={accountContactsPath}
      />
    );
  } else {
    return (
      <RenderDataProtectionOfficerWarning
        accountContactsPath={accountContactsPath}
      />
    );
  }
}

function RenderDataProtectionOfficerWarning({
  accountContactsPath,
}: AccountContactsPathData) {
  const theme = useTheme();
  // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'DefaultTheme'.
  const isBirch = theme?.name === 'birch';

  return (
    <React.Fragment>
      <DataProtectionOfficerWarning
        flavor="warning"
        data-provides="data_protection_officer_warning"
        redesign={isBirch}
      >
        <WarningIconContent>
          <ErrorIcon width="20px" height="20px" color={colors.darkYellow} />
        </WarningIconContent>
        <WarningContent>
          <WarningContentInformation>
            <ContentHeader>
              {t('gdpr.data_protection_officer_warning_header')}
            </ContentHeader>
            <ContentDescription>
              {t('gdpr.data_protection_officer_warning_description')}
            </ContentDescription>
          </WarningContentInformation>
          <Button href={accountContactsPath} target="_blank">
            {t('gdpr.data_protection_officer_warning_add_button')}
          </Button>
        </WarningContent>
      </DataProtectionOfficerWarning>
    </React.Fragment>
  );
}

function RenderDataProtectionOfficer({
  dataProtectionOfficer,
  accountContactsPath,
}: DataProtectionOfficerData) {
  return (
    <React.Fragment>
      <DataProtectionOfficerCard data-provides="data_protection_officer_card">
        <IconComponent>
          <DpoIcon />
        </IconComponent>
        <Content>
          <ContentHeader>
            {t('gdpr.data_protection_officer_header')}
          </ContentHeader>
          <ContentDescription>
            {t('gdpr.data_protection_officer_content_description')}
          </ContentDescription>
        </Content>
        <DataProtectionOfficerContent>
          <RenderCurrentDataProtectionOfficer
            dataProtectionOfficer={dataProtectionOfficer}
            accountContactsPath={accountContactsPath}
          />
        </DataProtectionOfficerContent>
      </DataProtectionOfficerCard>
    </React.Fragment>
  );
}

function RenderCurrentDataProtectionOfficer({
  dataProtectionOfficer,
  accountContactsPath,
}: DataProtectionOfficerData) {
  if (!dataProtectionOfficer) {
    return null;
  }

  return (
    <React.Fragment>
      <DataProtectionOfficerWrapper>
        <Name data-provides="data_protection_officer">
          {dataProtectionOfficer}
        </Name>
        <Link href={accountContactsPath} target="_blank">
          {t('gdpr.data_protection_officer_link')}
        </Link>
      </DataProtectionOfficerWrapper>
    </React.Fragment>
  );
}

DataProtectionOfficer.propTypes = {
  dataProtectionOfficer: PropTypes.string,
  accountContactsPath: PropTypes.string.isRequired,
};

const DataProtectionOfficerWarning = styled(FeedbackBlock)`
  ${/* @ts-expect-error 'Object' is not assignable to type 'CSSObject' */ ''}
  ${clearFix()};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 14px 20px;

  ${(props) => props.redesign && `margin-bottom: 24px;`};
`;
DataProtectionOfficerWarning.displayName = 'DataProtectionOfficerWarning';

const Content = styled(LeftComponentWrapper)`
  width: 100%;
`;

const WarningIconContent = styled(IconComponent)`
  margin-top: 3px;
`;

export const WarningContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const WarningContentInformation = styled.div`
  margin-left: 15.5px;
  margin-right: 15.5px;
`;

const DataProtectionOfficerContent = styled.div`
  width: 75%;
`;

const Name = styled.span`
  color: ${colors.darkestGrey};
  margin-right: 16px;
  font-weight: 400;
`;
Name.displayName = 'Name';

export const DataProtectionOfficerWrapper = styled.div`
  float: right;
  font-size: 14px;
  text-align: right;
  line-height: 22px;
`;

DataProtectionOfficerWrapper.displayName = 'DataProtectionOfficerWrapper';

export default DataProtectionOfficer;
